import React from 'react'

import {
  MarginSimulationResultModel,
  isOption1MarginResult,
  isOption2MarginResult,
} from '~/pages/Simulation/models/SimulationResultModel/MarginSimulationResultModel'

import { MarginSimulationTableForOption1 } from './MarginSimulationTableForOption1'
import { MarginSimulationTableForOption2 } from './MarginSimulationTableForOption2'

type Props = {
  result: MarginSimulationResultModel
}

export const MarginSimulationTable: React.FC<Props> = ({ result }) => {
  if (result === undefined) {
    return null
  }

  return (
    <>
      {isOption1MarginResult(result) && (
        <MarginSimulationTableForOption1 resultDetail={result} />
      )}
      {isOption2MarginResult(result) && (
        <MarginSimulationTableForOption2 resultDetail={result} />
      )}
    </>
  )
}
